import { QuoteResponse } from '../../models/services/api/postQuote';
import { QuoteDiscountTerms } from '../../pages/QuotePage/QuotePageSubs/QuotePageSubs.types';

/**
 * Current assumptions here
 *
 * - Only the appliance care quotes have discounts (currently no fixed term ones)
 * - Assuming ACH always has a discount and CC only has a discount if ACH does not have one, but this can be updated as needed
 * - Not using any annual_prepay discounts (Currently we don't present UI for it)
 */
export const getDiscountDisplayData = (quote: QuoteResponse): QuoteDiscountTerms => {
  let discountPaymentType: 'cc' | 'ach' = 'ach';

  if (quote?.offer?.contracts[0]?.contractAttributes.monthly_subs?.ach.discountProfileAttributes) {
    discountPaymentType = 'ach';
  }

  if (quote?.offer?.contracts[0]?.contractAttributes.monthly_subs?.cc.discountProfileAttributes) {
    discountPaymentType = 'cc';
  }

  const c = quote?.offer?.contracts.map(
    (contract) => contract.contractAttributes?.monthly_subs?.[discountPaymentType ?? 'ach'],
  );

  return {
    discountTerm: c[0]?.discountProfileAttributes?.discountTerm,

    discountPercentage: (c[0]?.discountProfileAttributes?.discountPercentage || 0) * 100,
    netFirstPaymentAmount: c[0]?.netFirstPaymentAmount ?? 0,
    netFirstPaymentAmountAfterPromotionalPeriod:
      c[0]?.discountProfileAttributes?.netFirstPaymentAmountAfterPromotionalPeriod,
    periodOfCover: quote.offer?.contracts[0].contractAttributes.periodOfCover,
    discountPaymentType: discountPaymentType,
  };
};
